module.exports = __webpack_public_path__ + "static/img/6.3de7de9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/6/1/sp/6.png
// module id = Dpem
// module chunks = 0